import * as React from 'react';
import { cn } from '@/lib/utils';

const ProjectCard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-project-card',
      // styles
      'relative flex w-full flex-wrap items-center justify-between gap-4 rounded-xl bg-neutral-lightest p-4',
      className
    )}
    {...props}
  />
));
ProjectCard.displayName = 'ProjectCard';

const ProjectCardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-project-card-header',
      // styles
      'flex w-full items-center gap-4',
      className
    )}
    {...props}
  />
));
ProjectCardHeader.displayName = 'ProjectCardHeader';

const ProjectCardFile = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-project-card-file',
      // styles
      'flex items-center gap-2 rounded-md bg-white p-2 pr-4',
      className
    )}
    {...props}
  />
));
ProjectCardFile.displayName = 'ProjectCardFile';

const ProjectCardFileTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn(
      'c-project-card-file-title',
      // styles
      'mb-0 block min-w-0 grow text-xs font-extrabold leading-snug text-primary-dark',
      className
    )}
    {...props}
  />
));
ProjectCardFileTitle.displayName = 'ProjectCardFileTitle';

export { ProjectCard, ProjectCardHeader, ProjectCardFile, ProjectCardFileTitle };
